module.exports = __webpack_public_path__ + "static/media/contact2.b5ea45ec.jpg";